import { FormattedMessage } from 'react-intl';
import type { FieldErrors } from 'react-hook-form';
import { toSnakeCase } from '@/shared/utils/string';
import type { ServerErrors } from '@/shared/utils/fieldErrors';

interface Props {
  field: string;
  errors: FieldErrors;
  serverErrors?: ServerErrors;
  messages?: Record<string, string>;
}

export default function FieldError({ field, errors, serverErrors, messages: messageMap }: Props) {
  const clientError = errors[field];
  if (clientError && messageMap) {
    const messageId = messageMap[clientError.type as string];
    if (messageId) {
      return <p className="mt-2 text-xs font-semibold text-red-600"><FormattedMessage id={messageId} /></p>;
    }
  }

  const snakeField = toSnakeCase(field);
  const serverMessage = serverErrors?.[snakeField]?.[0];
  if (serverMessage) {
    return <p className="mt-2 text-xs font-semibold text-red-600 first-letter:capitalize">{serverMessage}</p>;
  }

  return null;
}
